let transfer_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'transfers', name: 'transfers.list', component: () => import('./pages/Index.vue') },
      { path: 'transfers/create', name: 'transfers.create', component: () => import('./pages/Create.vue') },
      { path: 'transfers/create/advanced', name: 'transfers.create.advanced', component: () => import('./pages/advanced/AdvancedCreate.vue') },
      { path: 'transfers/:reference/edit', name: 'transfers.edit', component: () => import('./pages/advanced/AdvancedEdit.vue') },
      { path: 'transfers/send-money', name: 'send-money', component: () => import('./pages/SendMoney.vue') },
      { path: 'transfers/history', name: 'transfers.history', component: () => import('./pages/History.vue') },
      { path: 'transfers/pay', name: 'transfers.pay', component: () => import('./pages/Pay.vue') },
      { path: 'transfers/matchmaking', name: 'transfers.matchmaking', component: () => import('./pages/Matchmaking.vue') },
      { path: 'transfers/ift', name: 'transfers.ift', component: () => import('./pages/IFT.vue') },
    ]
  }
];

export default transfer_routes;
